export * from './use-template-resource';